import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.css";
import App from "./app";

ReactDOM.render(<App />, document.getElementById("root"));
